import type { SagaIterator } from "redux-saga";
import { call, put, select, takeLeading } from "redux-saga/effects";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as appStructureApi from "@/shop/api/appStructure/index";

import * as AppStructureActions from "./actions";
import type { IAppStructureNode } from "../../types/appStructure";
import type { ICatalogTreeSlice } from "../../types/catalog";
import { fetchCatalog } from "../catalog/actions";
import { fetchCatalogSaga } from "../catalog/saga";
import { getCatalogBaseCategories } from "../catalog/selectors";

function* fetchAppStructure(action: ActionType<typeof AppStructureActions.fetchAppStructure>): SagaIterator {
  const industryId: string = action.payload;
  try {
    yield put(AppStructureActions.fetchAppStructureStart());

    // catalog fetches the base categories, need to call the saga directly to wait for result
    yield call(fetchCatalogSaga, fetchCatalog({ industry: industryId }));

    // get the base categories from the store
    const baseCategories = (yield select(getCatalogBaseCategories)) as ICatalogTreeSlice[];

    // generate the app structure layout from the base categories
    const appStructure = (yield call(appStructureApi.getAppStructure, industryId, baseCategories)) as IAppStructureNode[];

    yield put(AppStructureActions.fetchAppStructureSuccess(appStructure));
  } catch (err) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    yield put(AppStructureActions.fetchAppStructureFail(err));
  }
}

export default function* appStructureSaga(): SagaIterator {
  yield takeLeading(getType(AppStructureActions.fetchAppStructure), fetchAppStructure);
}
